import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Progress } from 'src/components/progress';
import { PATHS } from 'src/constants/paths';
import {
  BULK_REPLACE_COMPONENT_INCLUDES,
  useGetComponent,
  useGetComponentTypesWithPagination,
} from 'src/hooks';
import { isEligibleForSelection } from 'src/utils';

import { ListComponentsPage } from '../../ListComponentsPage';

export const ReplaceComponentPage = () => {
  const [searchParams] = useSearchParams();
  const selectedComponentId = searchParams.get('componentId') || undefined;
  const navigate = useNavigate();
  const {
    data: componentDetails,
    error: componentListingError,
    isLoading: isLoadingSelectedComponent,
  } = useGetComponent(
    selectedComponentId || '',
    undefined,
    false,
    BULK_REPLACE_COMPONENT_INCLUDES,
  );
  const { data: componentTypes } = useGetComponentTypesWithPagination(
    [`page=${1}`],
    {
      staleTime: Infinity,
    },
  );

  useEffect(() => {
    if (
      !selectedComponentId ||
      componentListingError ||
      (componentDetails && !isEligibleForSelection(componentDetails))
    ) {
      navigate(PATHS.COMPONENTS, { replace: true });
    }
  }, [selectedComponentId, componentDetails, navigate, componentListingError]);

  return isLoadingSelectedComponent ? (
    <Progress />
  ) : (
    <ListComponentsPage
      componentDetails={componentDetails}
      componentTypes={componentTypes?.data}
    />
  );
};
